import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import '../css/stylez.scss'

const Header = () => (
  <div>
    <link href="https://fonts.googleapis.com/css?family=Julius+Sans+One|Open+Sans:300,400" rel="stylesheet"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/latest/css/bootstrap.min.css"/>
  </div>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="That's Nasty Jazz"
      meta={[
        { name: 'description', content: 'One Spicy Bicycle: Spicycle' },
        { name: 'keywords', content: 'graph mining, data science' },
      ]}
    />
    <Header />
      {children()}
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js